import { useId } from 'react'

type GateSvgProps = {
  open?: boolean
}

const GATE_BARS = [57, 67, 77, 87, 97, 107, 117, 127, 137, 147, 157, 167]

export const GateSvg = ({ open = false }: GateSvgProps) => {
  const uid = useId().replace(/:/g, '')

  return (
    <svg
      viewBox="0 0 220 170"
      width="100%"
      height="100%"
      className={`gate-svg ${open ? 'gate-svg-open' : ''}`}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id={`${uid}-gate-metal`} x1="0" y1="0" x2="1" y2="0">
          <stop offset="0" stopColor="#37434d" />
          <stop offset="0.48" stopColor="#8b969e" />
          <stop offset="1" stopColor="#303b45" />
        </linearGradient>
        <linearGradient id={`${uid}-gate-frame`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#68747d" />
          <stop offset="0.16" stopColor="#3d4953" />
          <stop offset="1" stopColor="#202a32" />
        </linearGradient>
        <filter
          id={`${uid}-gate-shadow`}
          x="-30%"
          y="-30%"
          width="160%"
          height="180%"
        >
          <feDropShadow dx="0" dy="3" stdDeviation="3" floodOpacity="0.2" />
        </filter>
        <filter
          id={`${uid}-gate-glow`}
          x="-200%"
          y="-300%"
          width="500%"
          height="700%"
        >
          <feGaussianBlur stdDeviation="3" />
        </filter>
        <clipPath id={`${uid}-gate-opening`}>
          <rect x="50" y="49" width="129" height="88" />
        </clipPath>
      </defs>

      <ellipse
        className="gate-svg-ground-glow"
        cx="110"
        cy="150"
        rx="88"
        ry="7"
      />
      <ellipse
        className="gate-svg-ground-shadow"
        cx="110"
        cy="149"
        rx="84"
        ry="4"
      />

      <g filter={`url(#${uid}-gate-shadow)`}>
        <rect
          className="gate-svg-foot"
          x="18"
          y="143"
          width="38"
          height="8"
          rx="1.5"
        />
        <rect
          className="gate-svg-foot"
          x="170"
          y="143"
          width="32"
          height="8"
          rx="1.5"
        />
        <path className="gate-svg-post-cap" d="M20 35h33l-4-8H24Z" />
        <path className="gate-svg-post-cap" d="M175 35h24l-3-8h-18Z" />
        <rect
          x="22"
          y="34"
          width="29"
          height="110"
          fill={`url(#${uid}-gate-metal)`}
        />
        <rect
          className="gate-svg-post-side"
          x="45"
          y="35"
          width="6"
          height="108"
        />
        <rect
          x="177"
          y="34"
          width="19"
          height="110"
          fill={`url(#${uid}-gate-metal)`}
        />
        <rect
          className="gate-svg-post-side"
          x="192"
          y="35"
          width="4"
          height="108"
        />

        <g clipPath={`url(#${uid}-gate-opening)`}>
          <g className="gate-svg-panel">
            <rect
              className="gate-svg-rail"
              x="50"
              y="51"
              width="128"
              height="8"
              fill={`url(#${uid}-gate-frame)`}
            />
            <rect
              className="gate-svg-rail"
              x="50"
              y="127"
              width="128"
              height="8"
              fill={`url(#${uid}-gate-frame)`}
            />
            {GATE_BARS.map(x => (
              <rect
                key={x}
                className="gate-svg-bar"
                x={x}
                y="57"
                width="3.2"
                height="72"
                rx="0.8"
                fill={`url(#${uid}-gate-frame)`}
              />
            ))}
          </g>
        </g>

        <rect
          className="gate-svg-sensor-glow"
          x="30"
          y="66"
          width="14"
          height="5"
          rx="2.5"
          filter={`url(#${uid}-gate-glow)`}
        />
        <rect
          className="gate-svg-sensor"
          x="30"
          y="66"
          width="14"
          height="5"
          rx="2.5"
        />
      </g>

      <g className="gate-svg-direction">
        <path d="M142 157h44" />
        <path d="m179 151 7 6-7 6" />
      </g>
    </svg>
  )
}
